<template>
  <v-card class="tx-card tx-filter-card">
    <v-card-text class="tx-filter">
      <p class="tx-section">Búsqueda</p>
      <v-layout row wrap>
        <v-flex md4 sm6 xs12>
          <label class="tx-label">N° de Factura</label>
          <v-text-field
            v-model="filter.term"
            class="tx-input"
            append-icon="search"
            placeholder="N° factura, control..."
            clearable
            solo
            flat
            hide-details
            @keyup.enter="emitSearch"
          ></v-text-field>
        </v-flex>
        <v-flex md4 sm6 xs12>
          <label class="tx-label">Laboratorio</label>
          <v-select
            v-model="filter.labId"
            class="tx-input"
            :items="laboratories"
            item-text="name"
            item-value="id"
            placeholder="Todos"
            no-data-text="Datos no disponibles"
            clearable
            solo
            flat
            hide-details
          ></v-select>
        </v-flex>
        <v-flex md4 sm6 xs12>
          <label class="tx-label">Distribuidor</label>
          <v-select
            v-model="filter.distId"
            class="tx-input"
            :items="distributors"
            item-text="name"
            item-value="id"
            placeholder="Todos"
            no-data-text="Datos no disponibles"
            clearable
            solo
            flat
            hide-details
            @change="onChangeDistributor"
          ></v-select>
        </v-flex>
      </v-layout>

      <p class="tx-section tx-section--spaced">Fecha</p>
      <v-layout row wrap>
        <v-flex md4 sm6 xs12>
          <label class="tx-label">Desde</label>
          <v-menu
            v-model="modal.startDate"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="filter.startDate"
                v-on="on"
                class="tx-input"
                append-icon="event"
                placeholder="Fecha inicial"
                readonly
                clearable
                solo
                flat
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filter.startDate"
              locale="es-es"
              color="#254f87"
              scrollable
              @input="modal.startDate = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex md4 sm6 xs12>
          <label class="tx-label">Hasta</label>
          <v-menu
            v-model="modal.endDate"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="filter.endDate"
                v-on="on"
                class="tx-input"
                append-icon="event"
                placeholder="Fecha final"
                readonly
                clearable
                solo
                flat
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filter.endDate"
              locale="es-es"
              color="#254f87"
              scrollable
              @input="modal.endDate = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex md4 sm12 xs12 class="tx-filter__actions">
          <button class="tx-btn tx-btn--ghost" @click="clearFilter">
            <v-icon small class="tx-btn__icon">filter_alt_off</v-icon>
            Limpiar
          </button>
          <button class="tx-btn tx-btn--secondary" @click="emitSearch">
            <v-icon small class="tx-btn__icon">search</v-icon>
            Buscar
          </button>
          <button class="tx-btn tx-btn--export" @click="$emit('download')">
            <v-icon small class="tx-btn__icon">cloud_download</v-icon>
            Exportar
          </button>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TransitFilter',
  data() {
    return {
      modal: {
        startDate: false,
        endDate: false,
      },
      distributors: [],
      laboratories: [],
      filter: {
        distId: '',
        labId: '',
        startDate: '',
        endDate: '',
        term: '',
      },
    }
  },
  created() {
    this.$store.dispatch('distributors/getAll', {}).then(response => {
      const data = (response && response.items) || []
      this.distributors = data.map(d => ({ name: d.name, id: d.id }))
    })
  },
  methods: {
    onChangeDistributor(id) {
      this.laboratories = []
      this.filter.labId = ''
      if (!id) return
      this.$store.dispatch('distributors/getById', { id }).then(response => {
        const data = (response && response.laboratories) || []
        this.laboratories = data.map(l => ({ name: l.name, id: l.id }))
      })
    },
    clearFilter() {
      this.filter = {
        distId: '',
        labId: '',
        startDate: '',
        endDate: '',
        term: '',
      }
      this.laboratories = []
      this.emitSearch()
    },
    emitSearch() {
      this.$emit('search', { ...this.filter })
    },
  },
}
</script>

<style scoped>
.tx-filter-card {
  margin-bottom: 4px;
}

.tx-filter {
  padding: 16px;
}

.tx-section {
  margin: 0 0 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #254f87;
}
.tx-section--spaced {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #e2e8f0;
}

.tx-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
  letter-spacing: 0.01em;
}

.tx-filter__actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.tx-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  background: #ffffff;
}

.tx-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.18s ease;
  text-transform: none;
}

.tx-btn__icon {
  font-size: 16px !important;
}

.tx-btn--ghost {
  background: #ffffff;
  color: #475569;
  border-color: #e2e8f0;
}

.tx-btn--ghost:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.tx-btn--secondary {
  background: rgba(37, 79, 135, 0.1);
  color: #254f87;
  border-color: rgba(37, 79, 135, 0.3);
}

.tx-btn--secondary:hover {
  background: rgba(37, 79, 135, 0.18);
}

.tx-btn--export {
  background: #ffffff;
  color: #16a34a;
  border-color: #bbf7d0;
}

.tx-btn--export:hover {
  background: #f0fdf4;
  border-color: #86efac;
}

@media (max-width: 959px) {
  .tx-filter__actions {
    justify-content: stretch;
  }
  .tx-filter__actions .tx-btn {
    flex: 1;
  }
}
</style>

<style>
/* === Inputs solo (clases globales de Vuetify) === */
.tx-input.v-text-field.v-text-field--solo .v-input__control > .v-input__slot,
.tx-input.v-select.v-text-field--solo .v-input__control > .v-input__slot {
  background: #ffffff !important;
  border: 1px solid #d1d5db !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.tx-input.v-input--is-focused .v-input__control > .v-input__slot {
  border-color: #254f87 !important;
  box-shadow: 0 0 0 3px rgba(37, 79, 135, 0.12) !important;
}

.tx-input .v-input__icon .v-icon {
  color: #94a3b8 !important;
  font-size: 19px !important;
}
</style>
